import { connect } from 'react-redux';

import { upsertSearchAlert } from '../../actions';
import { getCurrentSearchAlert } from '../../selectors';
import SearchAlertConfirmationButton from '../../components/SearchAlerts/SearchAlertConfirmationButton';

export default connect(
  state => ({
    hasAlert: Boolean(getCurrentSearchAlert(state)),
  }),
  {
    onConfirm: upsertSearchAlert,
  },
)(SearchAlertConfirmationButton);
